import { keyframes } from "@emotion/react";

export const rotateRing = keyframes`
  from {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  to {
    transform: translate(-50%, -50%) rotate(360deg);
  }
`;

export const rotatePlanet = keyframes`
  from {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  to {
    transform: translate(-50%, -50%) rotate(360deg);
  }
`;

export const pulseLine = keyframes`
  0%, 100% {
    opacity: 0.4;
    stroke-dashoffset: 0;
  }
  50% {
    opacity: 0.7;
    stroke-dashoffset: -8;
  }
`;

export const lightRay = keyframes`
  0%, 100% {
    opacity: 0.2;
    transform: scale(1);
  }
  50% {
    opacity: 0.4;
    transform: scale(1.1);
  }
`;

